<template>
  <div>
    <el-table :data="table_data" style="width: 100%" border>
      <el-table-column label="申请时间" prop="apply_time" width="180" align="center"></el-table-column>

      <el-table-column label="负责人信息" prop="project_master" min-width="250" align="center"></el-table-column>

      <el-table-column label="状态" align="center" width="150">
        <template slot-scope="scope">
          <span
            style="color:red;text-decoration: underline; cursor: pointer;"
            v-if="scope.row.foundagree == 2"
          >
            <el-popover
              placement="top"
              title="审核意见："
              width="200"
              trigger="click"
              :content="scope.row.found_opinion"
            >
              <span slot="reference">{{scope.row.foundagree_text}}</span>
            </el-popover>
          </span>
          <span
            v-else
            :style="{color:scope.row.foundagree == 1?'green':'#606266'}"
          >{{scope.row.foundagree_text}}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button-group>
            <template>
              <el-button
                type="primary"
                icon="el-icon-view"
                style="padding: 5px 7px"
                size="mini"
                @click="showApplyDetail(scope.row)"
              >申请详情</el-button>
            </template>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <detail
      v-if="if_open"
      v-model="if_open"
      :pid="project_id"
      :aid="apply_id"
      :type="project_type"
      :look="true"
      :title="info_title"
    ></detail>
  </div>
</template>
<script>
import detail from "./info";
export default {
  components: {
    detail
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      table_data: [],
      if_open: false, //申请详情
      project_id: null,
      apply_id: null,
      project_type: null,
      info_title: null
    };
  },

  watch: {},
  methods: {
    //获取申请详情
    showApplyDetail(data) {
      this.project_id = data.project_id;
      this.apply_id = data.project_apply_id;
      this.project_type = data.project_type;
      this.info_title = data.project_name;
      this.if_open = true;
    },

    getApplyList() {
      this.$db
        .post(this.$db.config.cf_project.info.child_list, {
          project_id: this.id
        })
        .then(res => {
          this.table_data = res.data;
        });
    }
  },
  mounted() {
    this.getApplyList();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/info/detail_apply.vue